/**
 * A function that provides access to various configuration values.
 * @returns {Object} An object containing configuration values.
 */
export function useConfig() {
  const config = window.chatwootConfig || {};

  /**
   * The host URL of the Chatwoot instance.
   * @type {string|undefined}
   */
  const hostURL = config.hostURL;

  /**
   * The VAPID public key for web push notifications.
   * @type {string|undefined}
   */
  const vapidPublicKey = config.vapidPublicKey;

  /**
   * An array of enabled languages in the Chatwoot instance.
   * @type {string[]|undefined}
   */
  const enabledLanguages = config.enabledLanguages;

  /**
   * Indicates whether the current instance is an enterprise version.
   * @type {boolean}
   */
  const isEnterprise = config.isEnterprise === 'true';

  /**
   * The name of the enterprise plan, if applicable.
   * Returns "community" or "enterprise"
   * @type {string|undefined}
   */
  const enterprisePlanName = config.enterprisePlanName;

  /**
   * CUSTOM: bocket-activity-messages-toggle — BKT-014
   * Whether the "hide system messages" toggle (and its default-hidden
   * behavior) is enabled. Defaults to true unless explicitly set to
   * the string 'false' — matches ENV.fetch(..., 'true') on the Rails side.
   * @type {boolean}
   */
  const hideActivityMessagesEnabled =
    config.hideActivityMessagesEnabled !== 'false';

  /**
   * CUSTOM: bocket-evolution-signature-toggle — BKT-015
   * Whether the per-account "sender name in WhatsApp messages" toggle is
   * enabled. Defaults to true unless explicitly set to the string 'false'.
   * @type {boolean}
   */
  const evolutionSignatureToggleEnabled =
    config.evolutionSignatureToggleEnabled !== 'false';

  return {
    hostURL,
    vapidPublicKey,
    enabledLanguages,
    isEnterprise,
    enterprisePlanName,
    hideActivityMessagesEnabled,
    evolutionSignatureToggleEnabled,
  };
}
